export default class JWTContainer {
    get content() {
        return this._content;
    }
    get csrf() {
        return this._csrf;
    }
    set csrf(val) {
        this._csrf = val;
        this.writeToLocalStorage();
    }
    constructor(_content, _csrf) {
        this._content = _content;
        this._csrf = _csrf;
        console.log("JWT enabled");
    }
    static tryToRestoreJWT() {
        let contentFromLocalStorage = localStorage.getItem("jwt");
        console.log("Got jwt");
        let csrfFromLocalStorage = localStorage.getItem("csrf");
        console.log("Got csrf");
        if (!csrfFromLocalStorage) {
            throw "csrf key in local storage should be enabled, or set something like 'no csff' if not desired";
        }
        if (contentFromLocalStorage && csrfFromLocalStorage)
            return new JWTContainer(contentFromLocalStorage, csrfFromLocalStorage);
        return null;
    }
    writeToLocalStorage() {
        if (this._content && this._csrf) {
            localStorage.setItem("jwt", this._content);
            localStorage.setItem("csrf", this._csrf);
            console.log("Written to localstorage");
        }
        else {
            console.error(`Did not write to localstorage: content: ${!!this._content}, csrf: ${!!this._csrf}`);
        }
    }
    revoke() {
        localStorage.removeItem("jwt");
        localStorage.removeItem("csrf");
        document.location.reload();
    }
}
